import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { AgentThreadToolDetailResponse } from "../AgentThreadRecord";

export function getQueryKey(threadId?: string, toolUseId?: string) {
  if (threadId === undefined || toolUseId === undefined) {
    return ["agentThreadToolDetails"];
  }

  return ["agentThreadToolDetails", threadId, toolUseId];
}

export function useToolDetails(
  threadId: string | undefined,
  toolUseId: string | undefined,
): UseQueryResult<AgentThreadToolDetailResponse, Error> {
  const { agentThreadService } = useDomainServices();

  return useQuery<AgentThreadToolDetailResponse, Error>({
    queryKey: getQueryKey(threadId, toolUseId),
    queryFn: ({ signal }) => {
      if (threadId === undefined || toolUseId === undefined) {
        return Promise.reject(new Error("Invalid threadId or toolUseId"));
      }

      return agentThreadService.getToolDetails(threadId, toolUseId, {
        abortSignal: signal,
      });
    },
    enabled: false,
  });
}
